module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "version-file"
  }, [_c('div', {
    staticClass: "online"
  }, [_c('h4', [_vm._v("线上版本")]), _vm._v(" "), _c('table', {
    staticClass: "bk-table has-table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.versionList), function(item, index) {
    return [(item.status === 0) ? _c('tr', [
      [_c('td', [_vm._v("版本号：" + _vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v("文件大小：" + _vm._s(item.file_size))]), _vm._v(" "), _c('td', [_vm._v("更新时间：" + _vm._s(item.update_time))])], _vm._v(" "), _c('td', [_c('div', {
        staticClass: "downloadbox"
      }, [_c('a', {
        staticClass: "bk-text-button",
        attrs: {
          "href": "javascript:"
        },
        on: {
          "click": _vm.openPopup
        }
      }, [_vm._v("更换线上版本")])])])
    ], 2) : _vm._e()]
  })], 2)])]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "account-right-item attention",
    on: {
      "click": _vm.slideDown
    }
  }, [_c('button', {
    staticClass: "bk-button bk-primary",
    attrs: {
      "title": "更新版本"
    },
    on: {
      "click": _vm.createVersion
    }
  }, [_c('i', {
    staticClass: "bk-icon icon-upload"
  }), _vm._v(" "), _c('span', [_vm._v("更新版本")])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isUpdate),
      expression: "!isUpdate"
    }],
    staticClass: "bk-table has-table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.versionList), function(item, index) {
    return [_c('tr', [_c('td', [_vm._v("版本号：" + _vm._s(item.name) + " "), (index === _vm.newIndex) ? _c('span', {
      staticClass: "new"
    }, [_vm._v("New")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("文件大小：" + _vm._s(item.file_size))]), _vm._v(" "), _c('td', [_vm._v("更新时间：" + _vm._s(item.update_time))]), _vm._v(" "), _c('td', [(item.status === 0) ? _c('span', {
      staticClass: "status onlineIcon",
      staticStyle: {
        "color": "#5bd18b"
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    }), _vm._v("线上版本\n              ")]) : _vm._e(), _vm._v(" "), (item.status === 1) ? _c('span', {
      staticClass: "status default"
    }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (item.status === 2) ? _c('span', {
      staticClass: "status info"
    }, [_vm._v("审核中")]) : _vm._e(), _vm._v(" "), (item.status === 4) ? _c('span', {
      staticClass: "status danger"
    }, [_vm._v("异常")]) : _vm._e(), _vm._v(" "), (item.status === 3) ? _c('span', {
      staticClass: "status fail"
    }, [_vm._v("未通过")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('i', {
      class: ['bk-icon', 'icon-download', {
        'icon-checking': item.status > 1
      }],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.download(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "tips"
    }, [_vm._v("版本下载")]), _vm._v(" "), (index === _vm.curDownloadIndex) ? _c('span', {
      staticClass: "download-box"
    }, [_c('span', {
      staticClass: "download-content sss",
      on: {
        "click": function($event) {
          return _vm.freeDownload(item)
        }
      }
    }, [_vm._v("普通版")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.sysType > 0),
        expression: "sysType > 0"
      }],
      staticClass: "download-content",
      on: {
        "click": function($event) {
          return _vm.customDownload(item, index)
        }
      }
    }, [_vm._v("企业定制版")])]) : _vm._e()]), _vm._v(" "), _c('i', {
      class: ['bk-icon', 'icon-delete', {
        'icon-active': item.version_id === _vm.changeVersionId
      }],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.secondaryPopup(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "tips"
    }, [_vm._v("删除该版本")])])]), _vm._v(" "), _c('td', {
      class: ['last', {
        'gruy': index === _vm.curVersionIndex
      }],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.slideUp(item, index)
        }
      }
    }, [_c('i', {
      class: ['bk-icon icon-angle-down', {
        'icon-angle-up': index === _vm.curVersionIndex
      }]
    }, [_c('span', {
      staticClass: "tips"
    }, [_vm._v("查看版本详情")])])])]), _vm._v(" "), (index === _vm.curVersionIndex) ? _c('tr', {
      staticClass: "bk-table-tr",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.slideDownPrevent(index)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "padding": "0"
      },
      attrs: {
        "colspan": "6"
      }
    }, [_c('div', {
      staticClass: "bk-table-list left"
    }, [_c('div', {
      staticClass: "bk-list-title"
    }, [_vm._v("\n                  文件列表\n                ")]), _vm._v(" "), _c('ul', [_c('li', {
      staticClass: "bk-list-li"
    }, [_c('i', {
      staticClass: "bk-icon icon-file-zip"
    }), _vm._v(" "), _c('div', {
      staticClass: "bk-list-content"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.file_list[0]))]), _vm._v(" "), _c('span', {
      staticClass: "capacity"
    }, [_vm._v(_vm._s(item.file_size))]), _vm._v(" "), (_vm.loadStatus === '1' && _vm.sindex === _vm.curFileIndex) ? _c('span', {
      staticClass: "bk-load"
    }, [_c('span', {
      staticClass: "loading"
    })]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
      staticClass: "bk-table-list right"
    }, [_c('div', {
      staticClass: "bk-list-title"
    }, [_vm._v("\n                  更新内容\n                ")]), _vm._v(" "), _c('p', {
      staticClass: "bk-list-title-para"
    }, [_vm._v(_vm._s(item.change_log))])])])]) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUpdate),
      expression: "isUpdate"
    }],
    staticClass: "bk-form form-version"
  }, [_c('div', {
    staticClass: "bk-form-item is-required"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("版本号：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.version),
      expression: "formData.version"
    }],
    staticClass: "bk-form-input",
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.formData.version)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "version", $event.target.value)
      }, _vm.checkValidate]
    }
  }), _vm._v(" "), (_vm.formData.isShow) ? _c('span', {
    staticClass: "tips version"
  }, [_vm._v(_vm._s(_vm.formData.tips))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item is-required"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("版本文件：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('div', {
    staticClass: "bk-form-textarea bk-form-upload",
    staticStyle: {
      "width": "705px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    staticClass: "upload-file",
    attrs: {
      "type": "file",
      "value": "",
      "name": "uploadFile",
      "maxRequestLength": "10240"
    },
    on: {
      "change": _vm.handleFile
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ableToUpload),
      expression: "ableToUpload"
    }],
    staticClass: "bk-form-content"
  }, [(_vm.formData.file.length !== 0) ? _c('div', {
    staticClass: "bk-upload-ul"
  }, [_c('div', {
    staticClass: "bk-list-li"
  }, [_c('i', {
    staticClass: "bk-icon icon-file-zip"
  }), _vm._v(" "), _c('div', {
    staticClass: "bk-list-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.formData.file.name))]), _vm._v(" "), (_vm.loadingStatus === 'start') ? _c('i', {
    staticClass: "bk-icon icon-close",
    on: {
      "click": function($event) {
        return _vm.deleteFile()
      }
    }
  }) : _c('i', {
    staticClass: "bk-icon icon-check-1"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingStatus === 'start'),
      expression: "loadingStatus === 'start'"
    }],
    staticClass: "bk-load"
  }, [_c('span', {
    class: [{
      'loading': _vm.loadingStatus === 'start'
    }, {
      'totalLoading': _vm.loadingStatus === 'complete'
    }]
  }), _vm._v(" "), _c('span')])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item is-required"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("更新内容：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.updataMsg),
      expression: "formData.updataMsg"
    }],
    staticClass: "bk-form-textarea",
    staticStyle: {
      "width": "705px"
    },
    attrs: {
      "name": "",
      "id": "",
      "placeholder": "请输入产品的详细介绍"
    },
    domProps: {
      "value": (_vm.formData.updataMsg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "updataMsg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item bk-form-action"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('a', {
    class: ['bk-button', 'bk-primary', {
      'is-loading': _vm.saveFlag === false
    }],
    attrs: {
      "id": "submit",
      "title": "保存"
    },
    on: {
      "click": _vm.saveUpdate
    }
  }, [_c('span', [_vm._v("保存")])]), _vm._v(" "), _c('a', {
    staticClass: "bk-button",
    attrs: {
      "title": "取消"
    },
    on: {
      "click": _vm.cancelSave
    }
  }, [_c('span', [_vm._v("取消")])])])])])]) : _vm._e(), _vm._v(" "), _c('loading', {
    staticClass: "loading",
    attrs: {
      "ifLoadingStart": _vm.isLoading
    }
  }), _vm._v(" "), (_vm.showPop) ? _c('div', {
    staticClass: "pop-wrapper"
  }, [_c('div', {
    staticClass: "pop-box"
  }, [_c('div', {
    staticClass: "pop-header clearfix"
  }, [_c('a', {
    staticClass: "fr",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showPop = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../images/common/close.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pop-body"
  }, [_vm._v("\n        确定删除该版本？\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pop-footer"
  }, [_c('a', {
    staticClass: "yes",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDelete()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('a', {
    staticClass: "no",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showPop = false
      }
    }
  }, [_vm._v("取消")])])])]) : _vm._e(), _vm._v(" "), _c('popup', {
    staticClass: "isSelect",
    attrs: {
      "title": _vm.popup.title,
      "show": _vm.popup.isShow
    },
    on: {
      "close": _vm.closePopup
    }
  }, [_c(_vm.currentView, {
    tag: "div",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "slot": "popup-body",
      "versionList": _vm.changeVersionList
    },
    on: {
      "close": _vm.closePopup,
      "changeVersion": _vm.toChangeId
    },
    slot: "popup-body"
  })], 1), _vm._v(" "), _c('popup', {
    staticClass: "public",
    attrs: {
      "show": _vm.downPopupShow
    },
    on: {
      "close": _vm.closeDownloadPopup
    }
  }, [_c('div', {
    attrs: {
      "slot": "popup-body"
    },
    slot: "popup-body"
  }, [(_vm.downloadStatus == 0) ? _c('div', {
    staticClass: "public-content"
  }, [_c('div', {
    staticClass: "round"
  }, [_c('img', {
    attrs: {
      "src": require("../../../images/application_detail/pops-download.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("正在为您自动下载“" + _vm._s(_vm.appName) + "”版本“" + _vm._s(_vm.curVersionName) + "”")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("如果您的浏览器不支持自动下载，请手动下载该作品")]), _vm._v(" "), _c('a', {
    staticClass: "confirm-button",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.enterpriseDownload.apply(null, arguments)
      }
    }
  }, [_vm._v("下载地址")])]) : _vm._e(), _vm._v(" "), (_vm.downloadStatus == 5) ? _c('div', {
    staticClass: "public-content"
  }, [_c('div', {
    staticClass: "round"
  }, [_c('img', {
    attrs: {
      "src": require("../../../images/application_detail/pops-download.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("正在为您自动下载“" + _vm._s(_vm.appName) + "”版本“" + _vm._s(_vm.curVersionName) + "”")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("如果您的浏览器不支持自动下载，请手动下载该作品")]), _vm._v(" "), _c('a', {
    staticClass: "confirm-button",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.commonDownload.apply(null, arguments)
      }
    }
  }, [_vm._v("下载地址")])]) : _vm._e(), _vm._v(" "), (_vm.downloadStatus == 1) ? _c('div', {
    staticClass: "public-content bank"
  }, [_c('version-file-download', {
    ref: "versionFileDownload",
    attrs: {
      "enterprise-list": _vm.appList,
      "user-cert-needed": _vm.userCertNeeded
    },
    on: {
      "update:userCertNeeded": function($event) {
        _vm.userCertNeeded = $event
      },
      "update:user-cert-needed": function($event) {
        _vm.userCertNeeded = $event
      },
      "confirm": _vm.selectDownloadType,
      "cancel": _vm.cancelDownloadSelect
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.downloadStatus == 3) ? _c('div', {
    staticClass: "public-content warning"
  }, [_c('div', {
    staticClass: "round"
  }, [_c('i', [_c('img', {
    attrs: {
      "src": require("../../../images/application_detail/pops-waring.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("文件编译失败，请重试")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("错误码：" + _vm._s(_vm.errorCode))]), _vm._v(" "), _c('a', {
    staticClass: "confirm-button againPack",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.doAgainPack
    }
  }, [_vm._v("重新打包")])]) : _vm._e(), _vm._v(" "), (_vm.downloadStatus == 4) ? _c('div', {
    staticClass: "public-content warning"
  }, [_c('div', {
    staticClass: "round"
  }, [_c('i', [_c('img', {
    attrs: {
      "src": require("../../../images/application_detail/pops-waring.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text",
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_vm._v("文件编译失败，请联系客服解决")]), _vm._v(" "), _c('a', {
    staticClass: "confirm-button service",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("联系客服")])]) : _vm._e(), _vm._v(" "), (_vm.downloadStatus == 2) ? _c('div', {
    staticClass: "public-content"
  }, [_c('div', {
    staticClass: "round tempo"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.packagePercent))]), _vm._v("%")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("正在为您编译文件准备APP包，请稍等片刻...")]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('p', [_vm._v("初次下载定制包需要验证企业信息")]), _vm._v(" "), _c('p', [_vm._v("打包过程可能需要几秒到几十秒的时间")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "popup-footer",
      "show": false
    },
    slot: "popup-footer"
  })]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "164px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "164px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "186px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "315px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "164px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "164px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "186px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "108px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "168px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "bk-icon icon-upload"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v("点击上传")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-c80fe1b2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/works/version_file.vue
// module id = fkdT
// module chunks = 16